import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportOutstandingIncomeSummary extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        ReportStore.loadReportPendingfinanceWork((result)=>{
            this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
        },()=>{
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        })
    }

    getNumberFormat(value,decimal=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let sum = 0
        data.forEach((item,index)=>{
            let val = (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field])
            sum += (val*1)
        })
        return sum
    }
    
    getTotalSummary() {
        let {data} = this.state
        let sum = 0
        data.forEach((item,index)=>{
            let wait_qo_amount = (item['wait_qo_amount']===''||item['wait_qo_amount']===null||item['wait_qo_amount']===undefined||isNaN(item['wait_qo_amount'])?0:item['wait_qo_amount'])
            let wait_approve_amount = (item['wait_approve_amount']===''||item['wait_approve_amount']===null||item['wait_approve_amount']===undefined||isNaN(item['wait_approve_amount'])?0:item['wait_approve_amount'])
            let wait_finance_amount = (item['wait_finance_amount']===''||item['wait_finance_amount']===null||item['wait_finance_amount']===undefined||isNaN(item['wait_finance_amount'])?0:item['wait_finance_amount'])
            let finance_amount = (item['finance_amount']===''||item['finance_amount']===null||item['finance_amount']===undefined||isNaN(item['finance_amount'])?0:item['finance_amount'])
            let wait_payment_amount = (item['wait_payment_amount']===''||item['wait_payment_amount']===null||item['wait_payment_amount']===undefined||isNaN(item['wait_payment_amount'])?0:item['wait_payment_amount'])
            sum += (wait_qo_amount*1)+(wait_approve_amount*1)+(wait_finance_amount*1)+(finance_amount*1)+(wait_payment_amount*1)
        })
        return sum
    }
    
    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
                <tr key={index}>
                    <td className='text-left'>{item.insurer_name}</td>
                    <td className='text-right'>{this.getNumberFormat(item.wait_qo_count)}</td>
                    <td className='text-right'>{this.getNumberFormat(item.wait_qo_amount)}</td>
                    <td className='text-right bg-0'>{this.getNumberFormat(item.wait_approve_count)}</td>
                    <td className='text-right bg-0'>{this.getNumberFormat(item.wait_approve_amount)}</td>
                    <td className='text-right bg-1'>{this.getNumberFormat(item.wait_finance_count)}</td>
                    <td className='text-right bg-1'>{this.getNumberFormat(item.wait_finance_amount)}</td>
                    <td className='text-right bg-2'>{this.getNumberFormat(item.finance_count)}</td>
                    <td className='text-right bg-2'>{this.getNumberFormat(item.finance_amount)}</td>
                    <td className='text-right bg-3'>{this.getNumberFormat(item.wait_payment_count)}</td>
                    <td className='text-right bg-3'>{this.getNumberFormat(item.wait_payment_amount)}</td>
                    <td className='text-right'>{this.getNumberFormat(parseFloat(item.wait_qo_amount)+parseFloat(item.wait_approve_amount)+parseFloat(item.wait_finance_amount)+parseFloat(item.finance_amount)+parseFloat(item.wait_payment_amount))}</td>
                </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    <tr>
                        <td rowSpan={3} className='text-center' style={{width:'110px'}}>สาขา</td>
                        <td colSpan={10} className='text-center'>สถานะ</td>
                        <td rowSpan={3} className='text-center' style={{width:'100px'}}>รวม</td>
                    </tr>
                    <tr>
                        <td colSpan={2} className='text-center'>รอส่งเรื่อง</td>
                        <td colSpan={2} className='text-center'>รออนุมัติราคา</td>
                        <td colSpan={2} className='text-center'>รอตั้งเบิก</td>
                        <td colSpan={2} className='text-center'>อนุมัติตั้งเบิก/<br/>แจ้งหนี้</td>
                        <td colSpan={2} className='text-center'>รอรับเงิน</td>
                    </tr> 
                    <tr>
                        <td className='text-center' style={{width:'60px'}}>เคลม</td>
                        <td className='text-center' style={{width:'60px'}}>มูลค่า</td>
                        <td className='text-center' style={{width:'60px'}}>เคลม</td>
                        <td className='text-center' style={{width:'60px'}}>มูลค่า</td>
                        <td className='text-center' style={{width:'60px'}}>เคลม</td>
                        <td className='text-center' style={{width:'60px'}}>มูลค่า</td>
                        <td className='text-center' style={{width:'60px'}}>เคลม</td>
                        <td className='text-center' style={{width:'60px'}}>มูลค่า</td>
                        <td className='text-center' style={{width:'60px'}}>เคลม</td>
                        <td className='text-center' style={{width:'60px'}}>มูลค่า</td>
                    </tr>  
                    {this.renderRowData(item,index)}
                    {index===length-1?
                    <tr>
                        <td className='text-center'></td>  
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_qo_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_qo_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_approve_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_approve_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_finance_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_finance_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('finance_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('finance_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_payment_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_payment_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getTotalSummary())}</td>
                    </tr>    
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportOutstandingIncomeSummary.defaultProps = {
    title: 'ตารางรายงานสรุปยอดรายได้ค้างรับประกัน',
    mode: '',
    workNo: ''
  }
  export default PrintReportOutstandingIncomeSummary;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportOutstandingIncomeSummary.js